import React, { ReactElement } from 'react';
import CtaButtons from '../CtaButtons';
import { isLightColor } from '../../utils';
import './styles/_branding_block.scss';

interface BrandingBlockProps {
  brandingColor: string;
  shareablePageId: string;
}

export default function BrandingBlock({
  brandingColor,
  shareablePageId
}: BrandingBlockProps): ReactElement {
  const hasDarkBackground = !isLightColor(brandingColor);
  return (
    <section
      className="branding-block"
      style={{ backgroundColor: brandingColor }}
    >
      <CtaButtons
        backgroundColor={hasDarkBackground ? '#fff' : undefined}
        shareablePageId={shareablePageId}
      />
    </section>
  );
}
